import {
  toWSDateString,
  WSElement,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { Batch, BatchSummaryExpand } from "@wingspanhq/wingspan-api-sdk";
import format from "date-fns/format";
import { queriesBatches } from "@query";

import { useImportBatchStatus } from "../../hooks/useImportBatchStatus";
import { CONTRACTOR_ENTITY_LABEL } from "../../routes/RouteImportContractorsBatchDetails/constants";
import { selectorImportBatchNames } from "../../selectors/selectorImportBatchNames";
import { selectorImportBatchNameSecondaryText } from "../../selectors/selectorImportBatchNameSecondaryText";

const CellContractorsCount: React.FC<{ batchId: string }> = ({ batchId }) => {
  const querySummary = queriesBatches.getBatchSummary.useQuery(
    { batchId, expand: [BatchSummaryExpand.BREAKDOWN] },
    { enabled: !!batchId }
  );

  if (querySummary.isLoading) {
    return <WSElement shimmer>loading</WSElement>;
  }

  const total = querySummary.data?.progress?.total;

  return <WSTableCell text={total === undefined ? "" : String(total)} />;
};

const CellImportStatus: React.FC<{ batchId: string }> = ({ batchId }) => {
  const { pill, secondaryText } = useImportBatchStatus(batchId, true);

  return <WSTableCell pill={pill} secondaryText={secondaryText} />;
};

export const getColumns = (): WSTableColumn<Batch>[] => [
  {
    config: {
      gridTemplateSizeMax: "0.4fr",
      justify: "start",
      header: { text: "Created" }
    },
    renderFunction: rowItem => {
      const createdAt = rowItem.data.events?.createdAt;

      return (
        <WSTableCell
          text={createdAt ? toWSDateString(createdAt, "monthDayYear") : "--"}
          secondaryText={
            createdAt ? format(new Date(createdAt), "hh:mm aaa") : undefined
          }
        />
      );
    }
  },
  {
    config: {
      gridTemplateSizeMax: "0.8fr",
      justify: "start",
      header: { text: "Name" }
    },
    renderFunction: rowItem => {
      const { batchName } = selectorImportBatchNames({
        batch: rowItem.data,
        entityLabel: CONTRACTOR_ENTITY_LABEL
      });

      return (
        <WSTableCell
          text={batchName}
          secondaryText={selectorImportBatchNameSecondaryText({
            batch: rowItem.data,
            entityLabel: CONTRACTOR_ENTITY_LABEL
          })}
        />
      );
    }
  },
  {
    config: {
      gridTemplateSizeMax: "0.4fr",
      justify: "start",
      header: { text: "Contractors count" },
      hideOnScreens: ["XS"]
    },
    renderFunction: rowItem => (
      <CellContractorsCount batchId={rowItem.data.id as string} />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "0.4fr",
      justify: "start",
      header: { text: "Import status" }
    },
    renderFunction: rowItem => (
      <CellImportStatus batchId={rowItem.data.id as string} />
    )
  }
];
